// extracted by mini-css-extract-plugin
module.exports = {"CustomizedXAxisTick":"CustomizedXAxisTick_CustomizedXAxisTick__tWArw","Small":"CustomizedXAxisTick_Small__ufhIH"};